import {
  type SecurityGroupPosition,
  type SecurityPosition,
  type SecurityPositionBySecurity,
  is401kTaxationType,
  isInstitutionalSecurityPosition,
  isInstitutionalSecurityPositionForSubAccount,
  isSecurityPositionBySecurity,
} from './data';

export type SellButtonProps = {
  financialSecurityId: string;
  assetTicker: string;
  shouldShow401kBlocked: boolean;
};

export type SellButtonComponent = React.FC<SellButtonProps>;

export function getSellButtonProps(
  position: SecurityPosition | SecurityPositionBySecurity,
  securityGroupPosition: SecurityGroupPosition
): SellButtonProps {
  if (isSecurityPositionBySecurity(position)) {
    const security = position.securityPositionsBySubAccount[0]?.securityPositions[0]?.security;
    const firstPosition = position.securityPositionsBySubAccount[0]?.securityPositions[0];
    const financialSecurityId =
      firstPosition && isInstitutionalSecurityPositionForSubAccount(firstPosition)
        ? firstPosition.financialSecurity.id
        : '';
    const shouldShow401kBlocked = position.securityPositionsBySubAccount.every(sp =>
      is401kTaxationType(sp.subAccount?.legalAccount?.taxationType)
    );

    return {
      financialSecurityId,
      assetTicker: security?.symbol ?? '',
      shouldShow401kBlocked,
    };
  }

  const financialSecurityId = isInstitutionalSecurityPosition(position) ? position.financialSecurity.id : '';
  const accountTaxationType =
    securityGroupPosition.securityPositionsBySecurity[0]?.securityPositionsBySubAccount[0]?.subAccount.legalAccount
      ?.taxationType;
  const shouldShow401kBlocked = accountTaxationType ? is401kTaxationType(accountTaxationType) : false;

  return {
    financialSecurityId,
    assetTicker: position.security.symbol,
    shouldShow401kBlocked,
  };
}
